import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAdminAuth } from "@/admin/AuthContext";
import { toast } from "sonner";
import { ArrowRight } from "@phosphor-icons/react";

export default function AdminLogin() {
  const { user, login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.email) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email.trim(), password);
    setLoading(false);
    if (res.ok) {
      toast.success("Signed in");
      navigate("/admin");
    } else {
      toast.error(res.error || "Login failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950 bg-blueprint-grid-fine text-white" data-testid="admin-login-page">
      <div className="w-full max-w-md px-6">
        <div className="mb-10 text-center">
          <div className="inline-flex items-center gap-2 mb-6">
            <div className="w-8 h-8 border border-zinc-600 flex items-center justify-center font-mono text-[10px] font-bold bg-zinc-900">C4S</div>
            <span className="font-display text-lg">cad4surveys</span>
          </div>
          <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-zinc-500">Admin Console</div>
          <h1 className="mt-3 font-display text-4xl tracking-tight">Sign in</h1>
        </div>
        <form
          onSubmit={onSubmit}
          className="bg-zinc-900 border border-zinc-800 p-8"
          data-testid="admin-login-form"
        >
          <label className="text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-500 block mb-2">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="username"
            className="w-full bg-zinc-950 border border-zinc-700 p-3 text-sm text-white focus:outline-none focus:border-[#0044FF]"
            data-testid="admin-login-email"
          />
          <label className="text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-500 block mb-2 mt-5">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            className="w-full bg-zinc-950 border border-zinc-700 p-3 text-sm text-white focus:outline-none focus:border-[#0044FF]"
            data-testid="admin-login-password"
          />
          <button
            type="submit"
            disabled={loading}
            className="mt-8 w-full bg-[#0044FF] hover:bg-[#0033CC] text-white py-3 font-medium inline-flex items-center justify-center gap-2 disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {loading ? "Signing in…" : "Sign in"}
            <ArrowRight size={14} weight="bold" />
          </button>
        </form>
        <p className="mt-6 text-center text-xs font-mono text-zinc-600">
          Set ADMIN_EMAIL / ADMIN_PASSWORD in /app/backend/.env to change credentials.
        </p>
      </div>
    </div>
  );
}
